import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './shared/styles/index.css';

/**
 * Application Entry Point
 * Bootstraps React application
 */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
